function getThumbnailSource (source) {
  // TODO: source should either an object or a string, not both
  if (typeof source === 'object' && source && source.url) {
    return source.url;
  }
  return source;
}

export function getYoutubeCode (source) {
  const url = getThumbnailSource(source);

  if (!url) return null;

  const youtubeCodeRegex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url && url.match(youtubeCodeRegex);

  if (url && !url.startsWith('http') && !url.includes('//')) {
    return url;
  }

  if (match && match[7] && match[7].length === 11) {
    return match[7];
  }

  return null;
}
